import firebase from "firebase/app";
import 'firebase/firestore';

export class Impressaootdeferido {

    
    constructor(dadosParaImpressao,marcacao) {
      this.dadosParaImpressao = dadosParaImpressao;
      this.marcacao = marcacao;
      if(marcacao==undefined){
        this.marcacao=[];
      }
      this.datasaida = new Date(this.dadosParaImpressao.props[0].datahorasaida.seconds*1000).toLocaleString("pt-BR");
      this.dataretorno = new Date(this.dadosParaImpressao.props[0].datahoraretorno.seconds*1000).toLocaleString("pt-BR");
    }  
  
    async PreparaDocumento() {
      const corpoDocumento = this.CriaCorpoDocumento();
      const documento = this.GerarDocumento();
      return documento;
    }
  
    CriaCorpoDocumento() {
      
     /* const body = this.dadosParaImpressao.map((prod) => {
        return [
          { text: prod.nome, fontSize: 8 },
          { text: prod.qtdEstoque, fontSize: 8 },
          { text: prod.qtdVendido, fontSize: 8 },
        ];
      });*/

      const body = (() => {
        return [{
            
        }];
      })
  
     
  
      let content = [body];
      
      return content;
    }
    
    
 GerarDocumento() {
        
console.log(this.dadosParaImpressao);
       
      const documento = {
        pageSize: 'A4',
        //pageMargins: [14, 53, 14, 48],
        pageOrientation: 'portait',
        info: {
            title: 'Ordem de Trânsito',
          },
          content: [
       

            {
                alignment: 'center',
                columns: [
                    
                    /*{
               /* image: logo,
                width: 50,
                height: 50, 
            },*/
    
                        {text: [
                            {text: 'Ministério da Educação \n' , style: 'header' },
                            {text: 'Universidade Federal de Santa Maria \n',style: 'subheader'},
                            {text: 'Pró-Reitoria de Infraestrutura \n',style: 'subheader'},
                            '\n',
                            {text: 'Ordem de Trânsito \n',style: 'subheader'},
                            
                            ]},
                        
                ] 
            },
            {text: '\n\n' },
            
            {
                alignment: 'center',
                columns: [
                
                            {text: 'Saída conforme solicitação nº:'},
                            {text: this.dadosParaImpressao.props[0].nsolicitacao},
                            {text: this.dadosParaImpressao.props[0].dsolicitacao},
                           
                            
                        
                ] 
            },
            {text: '\n\n' },
            'Centro/setor: ',
            {text: this.dadosParaImpressao.props[0].depsolicitacao[0].nomedepsol},
            '\n\n',
                            
            'O portador, motorista desta Universidade, está autorizado a realizar o deslocamento, conduzindo a viatura, com destino, objetivo e transportanto os passageiros conforme descrito a baixo ',
            
            '\n',
            {
              
              columns: [
              
                          {text: 'Motorista: '},
                          {text:this.dadosParaImpressao.props[0].motorista.label },

              ] 
          },
          '\n',
          {
              
            columns: [
            
                        {text: 'Destino: '},
                        {text:this.dadosParaImpressao.props[0].localdestino.description },

            ] 
        },
        '\n',
        {
              
          columns: [
          
                      {text: 'Veículo: '},
                      {text:this.dadosParaImpressao.props[0].veiculo.label },

          ] 
      },
      '\n',
      {
              
        columns: [
        
                    {text: 'Objetivo: '},
                    {text: this.dadosParaImpressao.props[0].objetivo},

        ] 
    },
    '\n',
        
           
            
                
           
          this.dadosParaImpressao.props[0].listapassageiros.map((item)=>{
              return[
                'Passageiro: ',
                {columns:[
                  {text:'Nome'},
                  {text:'SIAPE/Matrícula'},
                  {text:'Telefone'},
              ]},
                  {columns:[
                      {text:item.passageiro.nome},
                   {text:item.passageiro.siapemat},
                   {text:item.passageiro.telefone}, '\n',
                  ]}, 
                 
                   
                  
                   
           ];
           
           
          }),
               '\n', 
            
            {
                    alignment: 'center',
                style: 'tableExample',
                
                
                table: {
                    
                    body: [
                        ['Saída: ', this.datasaida],
                        ['Retorno: ',this.dataretorno],
                        
                    ]
                }
            },

            {text:'Marcações' , style: 'subheader' },
            

           this.marcacao.map((item)=>{
               return[{
                columns: [
                
    
                    {text:item.datahora},
                    {text:item.marcacao },
                    {text:'' },
                    
            ] 
        }
                
            ];
            
            
           }),
            
            
            
            
            
        '\n',
        'De acordo:',
        '(Nome e Siape)', '\n\n',
        this.dadosParaImpressao.props[0].autorizacoes.map((item)=>{
            return[
                       
    
                 {text:item.nomeassina, alignment: 'center'}, 
                 {text:item.siapeassina, alignment: 'center' },'\n',
                 
                 
         
     
             
         ];
         
         
        }),
            
    
    
    
            
        ],
      
          styles: {
            header: {
                fontSize: 13,
                bold: true,
                margin: [0, 0, 0, 10]
            },
            subheader: {
                fontSize: 12,
                bold: true,
                margin: [0, 10, 0, 5]
            },
            tableExample: {
                margin: [0, 5, 0, 15]
            },
            tableHeader: {
                bold: true,
                fontSize: 11,
                color: 'black'
            }
        },
        defaultStyle: {
            // alignment: 'justify'
            fontSize: 11,
        }
  
    };
      return documento;
    }
  }